export const UMB_MEDIA_ITEM_REPOSITORY_ALIAS = 'Umb.Repository.MediaItem';
export const UMB_MEDIA_STORE_ALIAS = 'Umb.Store.MediaItem';
